<template>
  <b-row>
    <template v-if="form.routes.length > 0">
      <b-col lg="4" cols="4">
        <div class="route-track pt-4">
          <div class="route-track-step" @click="selectedStatus('received_job')">
            <div class="route-track-status">
              <span :class="['route-track-status-dot', 'active']"></span>
              <span :class="['route-track-status-line', 'active']"></span>
            </div>
            <div class="route-track-text flex-fill">
              <div
                :class="[
                  'title-route',
                  { active: statusSelected === 'received_job' },
                ]">
                <h4 class="text-route">
                  <b-icon icon="person-badge" class="pr-1"></b-icon> รับงาน
                </h4>
              </div>
            </div>
          </div>
          <div
            class="route-track-step"
            v-for="(route, index) in form.routes"
            :key="index"
            @click="selectedRoute(index)">
            <div class="route-track-status">
              <span
                :class="[
                  'route-track-status-dot',
                  { active: form.routes[index].status === STATUS_SUCCESS },
                ]"></span>
              <span
                :class="[
                  'route-track-status-line',
                  { active: form.routes[index].status === STATUS_SUCCESS },
                ]"></span>
            </div>
            <div class="route-track-text flex-fill">
              <div
                :class="[
                  'title-route',
                  { active: statusSelected === `route_${index}` },
                ]">
                <h4 class="text-route">
                  <b-icon
                    :icon="
                      index === 0
                        ? 'pin-map-fill'
                        : index === form.routes.length - 1
                        ? 'symmetry-horizontal'
                        : 'record-circle-fill'
                    "
                    class="pr-1">
                  </b-icon>
                  {{
                    index === 0
                      ? "ต้นทาง"
                      : index === form.routes.length - 1
                      ? "ปลายทาง"
                      : `ระหว่างทาง จุดที่ ${index}`
                  }}
                </h4>
              </div>
            </div>
          </div>
          <div
            v-if="form.rate_type === 1"
            class="route-track-step"
            @click="selectedStatus('werehouse')">
            <div class="route-track-status">
              <span
                :class="[
                  'route-track-status-dot',
                  { active: form.distance_to_warehouse > 0 },
                ]"></span>
              <span
                :class="[
                  'route-track-status-line',
                  { active: form.distance_to_warehouse > 0 },
                ]"></span>
            </div>
            <div class="route-track-text flex-fill">
              <div
                :class="[
                  'title-route',
                  { active: statusSelected === 'werehouse' },
                ]">
                <h4 class="text-route">
                  <b-icon icon="shop-window" class="pr-1"></b-icon> กลับคลัง
                </h4>
              </div>
            </div>
          </div>
        </div>
      </b-col>
      <b-col lg="8" cols="8">
        <ReceivedJob v-if="statusSelected === 'received_job'" :form="form" />
        <RouteWarehouse
          v-else-if="statusSelected === 'werehouse'"
          :form="form" />
        <RouteDetails
          v-else-if="indexSelected !== null"
          :form="form"
          :indexSelected="indexSelected" />
      </b-col>
    </template>
    <template v-else>
      <b-col lg="12" class="my-4 text-center">
        <h4 class="text-muted">ยังไม่มีเส้นทางในขณะนี้</h4>
      </b-col>
    </template>
  </b-row>
</template>
<script>
import ReceivedJob from "./Details/ReceivedJob.vue";
import RouteDetails from "./Details/RouteDetails.vue";
import RouteWarehouse from "./Details/RouteWarehouse.vue";
import { STATUS_SUCCESS } from "@/util/constants.js";

export default {
  components: { ReceivedJob, RouteDetails, RouteWarehouse },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      STATUS_SUCCESS,
      statusSelected: "received_job",
      indexSelected: null,
    };
  },
  methods: {
    selectedStatus(status) {
      this.statusSelected = status;
    },
    selectedRoute(index) {
      this.indexSelected = index;
      this.statusSelected = `route_${index}`;
    },
  },
};
</script>
